import { render, staticRenderFns } from "./Intestorenspection.vue?vue&type=template&id=5589c174"
import script from "./Intestorenspection.vue?vue&type=script&lang=js"
export * from "./Intestorenspection.vue?vue&type=script&lang=js"
import style0 from "./Intestorenspection.vue?vue&type=style&index=0&id=5589c174&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports